import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'
import { Loader } from 'core-components/library/loader'

import { PARTNERS_COVERAGE_TABLE_KEYS } from '../../../../configs/coverageTables'
import { IPartnersCoverageGroup } from '../../../../model'
import { COVERAGE_TRANSLATION_KEYS } from '../../../translations'
import { CoverageCard } from '../coverageReportHeader/CoverageCard'
import { CoverageTable } from '../coverageTable/CoverageTable'
import { CoverageTableHeader } from '../coverageTable/CoverageTableHeader'

import styles from './CoverageReportTables.module.scss'

interface ICoverageReportTablesProps {
  /**
   * Coverage of the market selected in the Coverage Report header.
   * Holds the four coverage tables: topAccounts, powerElite, power, synergy.
   */
  group: IPartnersCoverageGroup | null
  isLoading: boolean
}

export const CoverageReportTables = ({ group, isLoading }: ICoverageReportTablesProps) => {
  return (
    <CoverageCard className={styles.cardRoot} variant="table">
      <Flex className={styles.root} flexDirection="column" gap="sm">
        {isLoading && <Loader dimension={{ height: 40 }} />}

        {!isLoading && !group && <Translation span text={COVERAGE_TRANSLATION_KEYS.noData} />}

        {!isLoading && group && (
          <>
            <h3 className={styles.title}>{group.title}</h3>

            <div className={styles.scroller}>
              <div className={styles.tables}>
                <CoverageTableHeader />

                {PARTNERS_COVERAGE_TABLE_KEYS.map((tableKey) => (
                  <CoverageTable
                    key={tableKey}
                    tableKey={tableKey}
                    rows={group.coverage[tableKey]}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </Flex>
    </CoverageCard>
  )
}
